import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';

import { getQueryVariablesForAGGSearch } from '../utils/aggVariables.ts';
import { aggResultMapper } from '../utils/aggResultMapper.ts';
import type { KeyableInterface } from '../types.ts';
import LiveSearchAGGQuery from './__generated__/LiveSearchAGGQuery.graphql.ts';
import type { LiveSearchAGGQueryType, LiveSearchAGGQueryVariables } from './AGGSearchTypes.ts';

type handleAGGSearchArgs = {
	searchInput: string;
	config: KeyableInterface;
	currentSpaceKey: string | undefined;
	confluenceInstance: string;
};

export type liveSearchAGGResult = {
	id: string;
	title: string;
	excerpt: string;
	spaceName: string;
	type: string;
	url: string;
};

export const handleAGGSearch = async ({
	searchInput,
	config,
	currentSpaceKey,
	confluenceInstance,
}: handleAGGSearchArgs): Promise<{
	results: liveSearchAGGResult[];
	size: number;
}> => {
	const results = await queryInterop<LiveSearchAGGQueryType, LiveSearchAGGQueryVariables>({
		query: LiveSearchAGGQuery,
		interopApolloAggClient: true,
		...getQueryVariablesForAGGSearch({
			searchInput,
			config,
			currentSpaceKey,
			confluenceInstance,
		}),
	}).then((response) => response.data.search?.search?.edges.map(aggResultMapper));

	return {
		results,
		size: results.length,
	};
};
